<template>
  <div>
    <el-row class="m-0 p-0" v-if="amReady">
      <div class="m-0 p-0 mb-4" v-if="formHeader">
        <h6>{{ this.getFormTitle }}</h6>
      </div>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
        <dg-select-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :options="vendorsList"
            :translateLabel="false"
            :translateLabels="false"
            :defaultValue="targetVendorId"
            :disabled="targetVendorId !== null"
            @amUpdated="vendorChanged"
            field_mark="required"
            label="Vendor"
            name="vendor_id"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
        <dg-select-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :options="destinationsDropDownList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="destinationChanged"
            field_mark="optional"
            htmlautocomplete="new-password"
            label="Destination"
            labelProperty="label"
            name="destination_id"
            placeholder="Canada / ATI"
            rules=""
            valueProperty="value"
        ></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            field_mark="optional"
            :translateLabel="false"
            label="Dialcode"
            name="dialcode"
            placeholder="234"
            rules=""></dg-text-field>
      </el-col>

      <el-col class="" :class="$langConfig.cssClass" :span="(!editMode)? 9 : 9">
        <dg-button class="mr-2 mt-4" v-if="selectedVendorId" :translate="false" text="VOS Rate" type="warning" icon="el-icon-download" fieldSize="mini" :click="downloadVOSRate"></dg-button>
        <dg-button class="mr-2 mt-4" :translate="false" text="Search" type="primary" icon="el-icon-refresh" fieldSize="mini" :click="makeSearch"></dg-button>
        <dg-button class="mr-2 mt-4" :translate="false" text="Reset Search" type="primary" icon="el-icon-refresh" fieldSize="mini" :click="resetSearchFields"></dg-button>
      </el-col>
    </el-row>

    <el-row class="mb-3" v-if="vendorIsSelected">
      <div class="">
        <div class="row">
          <div class="col-12 col-md-12">
            <span style="display: inline-block;margin-right: 20px;">
              <el-tag type="success">Rates Counter: {{ recordsCounter }}</el-tag> <small>24 record per page</small>
            </span>
            <pagination
                style="display: inline-block !important;"
                :currentPage="currentPage"
                :margin-pages="2"
                :navigateHandler="navigateToPage"
                :page-count="getPagesCount()"
                :page-range="4"
                paginateClass=""></pagination>
          </div>
        </div>
      </div>



      <el-table
          :data="rates"
          style="width: 100%">
        <el-table-column
            label="Destination"
            prop="destination">
        </el-table-column>
        <el-table-column
            label="dialcode"
            prop="dialcode">
        </el-table-column>
        <el-table-column
            label="Rate"
            prop="rate">
        </el-table-column>
        <el-table-column
            label="Old Rate"
            prop="old_rate">
        </el-table-column>
        <el-table-column
            label="Effective"
            prop="effective_date">
        </el-table-column>
        <el-table-column
            label="Created"
            prop="created_at">
        </el-table-column>
        <el-table-column
            label="Actions"
            prop="id">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeAction(scope.row.id, scope)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>


      <!--<el-col :span="24" class="mt-2">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                          v-show="!this.validData"></dg-label-field>
        </el-col>
      </el-col>-->
    </el-row>
  </div>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
  },
  mixins: [fieldController],
  props: {
    targetVendorId: {
      required: false,
      default: null
    },
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      selectedVendorId: false,
      destinationsDropDownList: [],
      dataModel: {
        vendor_id: null,
        destination_id: '',
        dialcode: '',
      },
      recordsCounter: 0,
      vendorIsSelected: false,
      pageChunkSize: 24,
      currentPage: 1,
      control: this,
      amReady: true,
      userSearch: null,
      requestOn: false,
      editable: !this.editMode,
      vendorsList: [],
      rates: [],
      module: {
        ...module
      }
    }
  },
  computed: {
    ...$mapState('voip-dialplan-state', ['openedEntity']),
    ...$mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  beforeMount() {
    if (this.targetVendorId) {
        this.vendorChanged()
    }

    this.getVendorDropDownList({}).then(r => {
      this.vendorsList = r
    })

    this.getDestinationsDropdownlist().then((r) => {
      this.destinationsDropDownList = r
      this.amReady = true
    })
  },
  methods: {
    ...$mapActions('voip-vendor-api', {
      getEntityList: 'list',
      downloadVosRateAction: 'downloadVosRate'
    }),
    downloadVOSRate (params) {
      this.downloadVosRateAction({id: this.selectedVendorId})
    },
    makeSearch () {
      this.navigateToPage(1)
    },
    resetSearchFields () {
      this.fields['destination_id'].field.field_value = ''
      this.fields['destination_id'].field.updateValue()
      this.fields['destination_id'].field.validateMessage = ''

      this.fields['dialcode'].field.field_value = ''
      this.fields['dialcode'].field.updateValue()
      this.fields['dialcode'].field.validateMessage = ''

      this.dataModel.destination_id = ''
      this.dataModel.dialcode = ''
      this.vendorChanged()
    },
    destinationChanged() {},
    vendorChanged(inputField) {
      if (!inputField) return;
      let val = inputField.field.field_value;
      this.selectedVendorId = val

      this.vendorIsSelected = true
      this.navigateToPage(1)
    },
    ...$mapActions('voip-vendor-api', {
      getVendorDropDownList: 'getDropDownList',
      getVendorRate: 'getVendorRate'
    }),
    ...$mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList'
    }),
    ...$mapActions('voip-dialplan-state', ['addEntity']),
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getVendorRate({
        id: this.dataModel.vendor_id,
        page,
        destinationId: this.dataModel.destination_id,
        dialcode: this.dataModel.dialcode,
        rate_type:'voice'
      }).then((r) => {
        this.rates = r.data.rows
        this.recordsCounter = r.data.count
      })
      this.currentPage = page;
      // $router.push({name: 'module->voip-vendor->rates-panel->tab', params: { tabName: 'viewRates', listPage: page}})
    },
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      $vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    getEntityField() {
      return JSON.parse(this.openedEntity.fields);
    },
    removeAction(rateId, scope) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/removeRate', {id: rateId}).then(response => {
        this.rates.splice(scope.$index, 1)
        this.recordsCounter -= 1
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return
        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'createManualRate';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          });
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
